import { apiClient } from "lib/apiClient";

export const deleteCompAttachments = async <T>(id: string): Promise<T> => {
  const response = await apiClient.delete(`/comps/attachments/${id}
  `);

  return response.data;
};
